import { useMemo } from "react";
import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { KINDS, eng } from "@/components/social/SocialTopMedia";

const DAYS = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
const avg = (arr, f) => (arr.length ? Math.round(arr.reduce((s, x) => s + (f(x) || 0), 0) / arr.length) : 0);
const bestBy = (list, keyf) => {
  const g = {};
  list.forEach((m) => (g[keyf(m)] = g[keyf(m)] || []).push(m));
  return Object.entries(g).filter(([, v]) => v.length >= 2).map(([k, v]) => ({ k, reach: avg(v, (m) => m.insights?.reach), n: v.length })).sort((a, b) => b.reach - a.reach);
};

const Box = ({ title, children, testid }) => (
  <Card className="p-5" data-testid={testid}>
    <p className="mb-3 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">{title}</p>
    {children}
  </Card>
);

export const SocialInsights = ({ media }) => {
  const { types, days, hours } = useMemo(() => {
    const feed = media.filter((m) => m.kind !== "STORY" && m.insights?.reach);
    const t = Object.keys(KINDS).map((k) => {
      const l = media.filter((m) => m.kind === k);
      return { k, n: l.length, reach: avg(l, (m) => m.insights?.reach), eng: avg(l, eng), saved: avg(l, (m) => m.insights?.saved) };
    }).filter((x) => x.n);
    return {
      types: t,
      days: bestBy(feed, (m) => new Date(m.timestamp).getDay()).slice(0, 3),
      hours: bestBy(feed, (m) => new Date(m.timestamp).getHours()).slice(0, 3),
    };
  }, [media]);
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Box title="Resa media per formato" testid="social-by-type">
        {types.map((t) => (
          <div key={t.k} className="flex justify-between border-b border-border/40 py-1.5 text-sm last:border-0">
            <span>{KINDS[t.k]} <span className="text-xs text-muted-foreground">({t.n})</span></span>
            <span className="text-right text-xs"><b>{num(t.reach)}</b> raggiunti · {num(t.eng)} interazioni</span>
          </div>
        ))}
      </Box>
      <Box title="Giorni migliori per pubblicare" testid="social-best-days">
        {days.length ? days.map((d) => <p key={d.k} className="py-1 text-sm">{DAYS[d.k]} <span className="text-xs text-muted-foreground">· media {num(d.reach)} raggiunti ({d.n} post)</span></p>)
          : <p className="text-sm text-muted-foreground">Servono più post per capirlo</p>}
      </Box>
      <Box title="Orari migliori" testid="social-best-hours">
        {hours.length ? hours.map((h) => <p key={h.k} className="py-1 text-sm">Ore {h.k}:00 <span className="text-xs text-muted-foreground">· media {num(h.reach)} raggiunti ({h.n} post)</span></p>)
          : <p className="text-sm text-muted-foreground">Servono più post per capirlo</p>}
      </Box>
    </div>
  );
};

export const SocialAudience = ({ demo }) => {
  const top = (k, n = 5) => (demo[k] || []).slice(0, n);
  if (!Object.keys(demo).length) return null;
  const G = { F: "Donne", M: "Uomini", U: "Non indicato" };
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Box title="Città dei follower" testid="social-cities">{top("city").map((c) => <p key={c.key} className="flex justify-between py-0.5 text-sm"><span>{c.key}</span><span>{num(c.value)}</span></p>)}</Box>
      <Box title="Età dei follower" testid="social-ages">{top("age", 7).map((c) => <p key={c.key} className="flex justify-between py-0.5 text-sm"><span>{c.key}</span><span>{num(c.value)}</span></p>)}</Box>
      <Box title="Genere" testid="social-gender">{top("gender").map((c) => <p key={c.key} className="flex justify-between py-0.5 text-sm"><span>{G[c.key] || c.key}</span><span>{num(c.value)}</span></p>)}</Box>
    </div>
  );
};
